import Localized from 'src/constants/AppStrings';
import Styles from '../../../Styles';
import {Platform, View} from 'react-native';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import CommonUtils from '../newui/commonutils';
import AccountStore from 'src/stores/AccountStore';
import UIManager from '../../../elements/ui/UIManager';
import MainConsumerContext from '../../../MainConsumerContext';
import React, {ContextType} from 'react';
import Logger from 'src/logging/Logger';
import MenuOption from 'src/components/elements/MenuOption';
import InfoIcon from 'src/components/elements/InfoIcon';
import Settings from 'src/Settings';
import LocaleDropdown from 'src/components/elements/account/LocaleDropdown';
import AllyTextInput from 'src/components/elements/AllyTextInput';
import BirthYearDropdown from 'src/components/elements/account/BirthYearDropdown';
import BirthMonthDropdown from 'src/components/elements/account/BirthMonthDropdown';
import GenderDropdown from 'src/components/elements/account/GenderDropdown';

export function backHeaderDescriptor(): string {
  return Localized.Labels.personal_info;
}

export function maxFontSizeMultipleDescriptor(): number {
  return Styles.FontSizeMultiplier.maxfm11;
}

export function getDeleteAcntDisclaimer(is365?: boolean) {
  return is365 ? 'voluntary_deletion_1_redesign' : 'voluntary_deletion_1';
}

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    instructions: {
      alignSelf: 'stretch',
      color: Styles.black,
      fontSize: Styles.Fonts.f2,
      marginVertical: Styles.Spacing.m1,
      textAlign: 'left',
    },
    content: {
      padding: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m6,
    },
  };
}

export function getChangePasswordStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    content: {
      paddingTop: Styles.Spacing.m1,
      marginLeft: -7.5,
      width: Platform.OS === 'web' ? '50%' : '100%',
      flex: 1,
      paddingLeft: Styles.Spacing.m3,
    },
  };
}
export function deleteBtnColorrDescriptor(): string {
  return Styles.dangerColor;
}

export function getDeleteAcntStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    disclaimerTextBold: {
      fontWeight: 'bold',
      marginBottom: Styles.Spacing.m1,
    },
    disclaimerText: {
      marginBottom: Styles.Spacing.m1,
    },
    deleteAcntTitle: {
      fontSize: 22,
      fontWeight: '700',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    deleteAcntDesc: {
      paddingTop: 16,
      fontSize: 16,
      fontWeight: '400',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
      paddingBottom: 25,
    },
    btndelete: {
      fontSize: 16,
      fontWeight: '700',
      color: '#fff',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    btndeleteTakeMe: {
      fontSize: 16,
      fontWeight: '700',
      color: '#D7263D',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
      paddingHorizontal: 24,
    },
  };
}

export function getEditMarketCardStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    header: {
      paddingStart: Styles.Spacing.m3,
      color: Styles.black,
      fontSize: Styles.Fonts.f2,
      marginTop: Styles.Spacing.m3,
      fontWeight: '500',
      marginBottom: Styles.Spacing.m2,
    },
    scanditContainer: {
      alignSelf: 'stretch',
      borderRadius: Styles.Spacing.m2,
      flex: 1,
      marginBottom: Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      overflow: 'hidden',
    },
  };
}

export function getHelpStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    answer: {
      fontSize: Styles.Fonts.f1,
      flex: 1,
      flexWrap: 'wrap',
      color: Styles.darkColor,
    },
    errBtn: {
      fontSize: 16,
      fontWeight: '700',
      color: '#fff',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    header: {
      marginTop: Styles.Spacing.m3,
      fontWeight: '500',
      color: Styles.darkColor,
      paddingStart: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f2,
      marginBottom: Styles.Spacing.m2,
    },

    link: {
      color: Styles.primaryColor,
    },
    question: {
      color: Styles.primaryColor,
      fontSize: Styles.Fonts.f1,
      fontWeight: '600',
      marginRight: Styles.Spacing.m1,
    },
    text: {
      marginTop: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m4,
      color: Styles.darkColor,
      paddingHorizontal: Styles.Spacing.m3,
    },
    helpErrTitle: {
      fontSize: 22,
      fontWeight: '700',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    helpErrDesc: {
      paddingTop: 16,
      fontSize: 16,
      fontWeight: '400',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
  };
}

export function getManageAcntStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    content: {
      paddingHorizontal: Styles.Spacing.m3,
      paddingTop: Styles.Spacing.m1,
      backgroundColor: Styles.Colors.PayNew.white01,
    },
    localeContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    localeDropdown: {
      flex: 1,
      marginTop: Styles.Spacing.m2,
    },
    localeIcon: {
      marginRight: Styles.Spacing.m0,
      marginLeft: Styles.Spacing.m1,
      marginTop: Styles.Spacing.m3,
    },
    menu: {
      height: Styles.Heights.h6,
      marginBottom: Styles.Spacing.m5,
      marginTop: Styles.Spacing.m2,
      marginHorizontal: 0,
    },
  };
}

export function getParentContainerStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    parentContainer: {
      backgroundColor: Styles.white,
    },
  };
}

export function getUserProfileTextStyleDescriptors() {
  return {
    name: {},
    emailLocationText: {},
    locationView: {},
    versionFontstyle: {},
  };
}
export function getFirstNameManageAccount(state, maxCharacters, doSetState) {
  return (
    <AllyTextInput
      label={Localized.Labels.first_name}
      value={state.firstName}
      accessible={true}
      accessibilityLabel={Localized.Labels.first_name}
      accessibilityValue={{text: state.firstName}}
      onChangeText={doSetState}
      autoCapitalize="words"
      maxLength={maxCharacters}
      maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
    />
  );
}

export function getLastNameManageAccount(state, maxCharacters, doSetState) {
  return (
    <AllyTextInput
      label={Localized.Labels.last_name}
      value={state.lastName}
      accessible={true}
      accessibilityLabel={Localized.Labels.last_name}
      accessibilityValue={{text: state.lastName}}
      onChangeText={doSetState}
      autoCapitalize="words"
      maxLength={maxCharacters}
      maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
    />
  );
}

export function getGenderDropDownManageAccount(
  state,
  genderSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      style={{marginTop: Styles.Spacing.m2}}
      accessible={true}
      accessibilityLabel="Gender"
      accessibilityRole="menu"
      accessibilityValue={{text: state.gender}}
      accessibilityState={{
        expanded: state.genderMenuVisible,
      }}
      accessibilityElementsHidden={
        state.birthMonthMenuVisible || state.birthYearMenuVisible
      }
      importantForAccessibility={
        state.birthMonthMenuVisible || state.birthYearMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Gender'}
      aria-valuetext={state.gender}
      aria-expanded={state.genderMenuVisible}
    >
      <GenderDropdown
        selectedValue={state.gender}
        onSelect={genderSelected}
        onVisibilityChange={() =>
          handleMenuVisibilityChange(!state.genderMenuVisible, 'gender')
        }
      />
    </View>
  );
}

export function getBirthMonthDropDownManageAccount(
  state,
  birthMonthSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      accessible={true}
      accessibilityLabel="Birth Month"
      accessibilityRole="menu"
      accessibilityValue={{text: state.birthMonth}}
      accessibilityState={{
        expanded: state.birthMonthMenuVisible,
      }}
      accessibilityElementsHidden={
        state.genderMenuVisible || state.birthYearMenuVisible
      }
      importantForAccessibility={
        state.genderMenuVisible || state.birthYearMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Birth Month'}
      aria-valuetext={state.birthMonth}
      aria-expanded={state.birthMonthMenuVisible}
    >
      <BirthMonthDropdown
        selectedValue={state.birthMonth}
        onSelect={birthMonthSelected}
        onVisibilityChange={() =>
          handleMenuVisibilityChange(!state.birthMonthMenuVisible, 'birthMonth')
        }
        showNumbers={false}
        year={state.birthYear}
      />
    </View>
  );
}

export function getBirthYearDropDownManageAccount(
  state,
  birthMonthYearSelected,
  birthYearSelected,
  handleMenuVisibilityChange,
) {

  return (
    <View
      accessible={true}
      accessibilityLabel="Birth Year"
      accessibilityRole="menu"
      accessibilityValue={{text: state.birthYear}}
      accessibilityState={{
        expanded: state.birthYearMenuVisible,
      }}
      accessibilityElementsHidden={
        state.genderMenuVisible || state.birthMonthMenuVisible
      }
      importantForAccessibility={
        state.genderMenuVisible || state.birthMonthMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Birth Year'}
      aria-valuetext={state.birthYear}
      aria-expanded={state.birthYearMenuVisible}
    >
      <BirthYearDropdown
        selectedValue={state.birthYear}
        onSelect={birthYearSelected}
        onVisibilityChange={() =>
          handleMenuVisibilityChange(!state.birthYearMenuVisible, 'birthYear')
        }
      />
    </View>
  );
}

export function getJobTitleManageAccount(state, doSetState) {
  return (
    <View
      style={{marginTop: Styles.Spacing.m1}}
      accessibilityElementsHidden={
        state.genderMenuVisible ||
        state.birthMonthMenuVisible ||
        state.birthYearMenuVisible
      }
      importantForAccessibility={
        state.genderMenuVisible ||
        state.birthMonthMenuVisible ||
        state.birthYearMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
    >
      <AllyTextInput
        label={Localized.Labels.job_title}
        value={state.jobTitle}
        accessible={true}
        accessibilityLabel={Localized.Labels.job_title}
        accessibilityValue={{text: state.jobTitle}}
        onChangeText={doSetState}
        autoCapitalize="words"
        maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
      />
    </View>
  );
}

export function getSystemLanguageDropDownManageAccount(
  maxWidth,
  state,
  localeSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      style={
        getManageAcntStyleDescriptor() &&
        getManageAcntStyleDescriptor()['localeContainer']
      }
    >
      <View
        style={[
          getManageAcntStyleDescriptor()['localeDropdown'],
          getManageAcntStyleDescriptor()['dropdownContainer'],
          {
            width: maxWidth - Styles.Spacing.m2,
            marginHorizontal: 2,
          },
        ]}
        accessible={true}
        accessibilityLabel="Locale drop down"
        accessibilityRole="menu"
        accessibilityValue={{text: state.locale}}
        accessibilityState={{
          expanded: state.localeMenuVisible,
        }}
        accessibilityElementsHidden={
          state.genderMenuVisible ||
          state.birthMonthMenuVisible ||
          state.birthYearMenuVisible
        }
        importantForAccessibility={
          state.genderMenuVisible ||
          state.birthMonthMenuVisible ||
          state.birthYearMenuVisible
            ? 'no-hide-descendants'
            : 'yes'
        }
        role="menu"
        aria-label="Locale drop down"
        aria-valuetext={state.locale}
        aria-expanded={state.localeMenuVisible}
      >
        <LocaleDropdown
          style={{flex: 1}}
          selectedValue={state.locale}
          onSelect={localeSelected}
          onVisibilityChange={() =>
            handleMenuVisibilityChange(!state.localeMenuVisible, 'locale')
          }
        />
      </View>
      <View
        accessible={true}
        accessibilityLabel="Information"
        accessibilityRole="imagebutton"
        accessibilityHint="Double tap to show the help information"
        aria-label="Information"
        role="button"
        style={
          getManageAcntStyleDescriptor() &&
          getManageAcntStyleDescriptor()['localeIcon']
        }
      >
        <InfoIcon
          infoMessage={Localized.Labels.formatString(
            Localized.Labels.system_language_explanation,
            Settings.appDisplayName,
          )}
        />
      </View>
    </View>
  );
}

export function getChangeEmail(handleChangeEmail) {
  return (
    <MenuOption
      accessibilityLabel="Change Email"
      label={Localized.Labels.change_email}
      onPress={handleChangeEmail}
      style={getManageAcntStyleDescriptor()['menu']}
    />
  );
}

export function showIcon() {
  return null;
}
export function signOutColor() {
  return null;
}
export function signOutButtonType() {
  return ButtonType.outline;
}

export function getHelpAndOtherStr() {
  return Localized.Labels.help_and_other;
}

export function getSettingsOptions(
  handlePrivacyPolicyUrl: () => void,
  context: ContextType<typeof MainConsumerContext> | null,
  addPassClicked: () => void,
) {
  const settings = [];
  settings.push({
    accessibilityLabel: Localized.Labels.personal_info,
    accessibilityHint: 'Double tap to view or update your personal information',
    onPressed: CommonUtils.toManageAccount,
    label: Localized.Labels.personal_info,
  });
  settings.push({
    accessibilityLabel: Localized.Labels.balances,
    accessibilityHint: 'Double tap to view your balances',
    onPressed: CommonUtils.toBalances,
    label: Localized.Labels.balances,
  });
  settings.push({
    accessibilityLabel: Localized.Labels.link_location,
    accessibilityHint: 'Double tap to go to link location',
    onPressed: CommonUtils.handleLinkLocation,
    label: Localized.Labels.link_location,
  });
  if (AccountStore.getMarketCard()) {
    settings.push({
      accessibilityLabel: Localized.Labels.edit_market_card,
      accessibilityHint: 'Double tap to edit your market card',
      onPressed: CommonUtils.handleMarketCard,
      label: Localized.Labels.edit_market_card,
    });
  } else {
    settings.push({
      accessibilityLabel: Localized.Labels.add_market_card,
      accessibilityHint: 'Double tap to add a market card',
      onPressed: CommonUtils.handleMarketCard,
      label: Localized.Labels.add_market_card,
    });
  }
  if (!context?.state.passExists && context?.state?.canAddPass) {
    settings.push({
      accessibilityLabel: Localized.Labels.add_to_apple_wallet,
      accessibilityHint: 'Double tap to navigate to add your apple wallet',
      onPressed: addPassClicked,
      label: Localized.Labels.add_to_apple_wallet,
    });
  }
  return settings;
}

export function getHistoryOptions() {
  return null;
}

const getSecurityOptions = () => {
  let security = [];
  security = [
    {
      accessibilityLabel: Localized.Labels.change_password,
      accessibilityHint: 'Double tap to change your password',
      onPressed: CommonUtils.handleChangePassword,
      label: Localized.Labels.change_password,
    },
    {
      accessibilityLabel: Localized.Labels.change_pin,
      accessibilityHint: 'Double tap to change your pin',
      onPressed: CommonUtils.handleChangePin,
      label: Localized.Labels.change_pin,
    },
  ];
  return security;
};

const getHelpAndOtherOptions = (handlePrivacyPolicyUrl: () => void) => {
  let helpAndOther = [];
  helpAndOther = [
    {
      accessibilityLabel: UIManager.getHelpLabel(),
      accessibilityHint: 'Double tap to navigate to the help screen',
      onPressed: CommonUtils.contactClicked,
      label: UIManager.getHelpLabel(),
    },
    {
      accessibilityLabel: Localized.Labels.view_privacy_policy,
      accessibilityHint: 'Double tap to view the privacy policy',
      onPressed: handlePrivacyPolicyUrl,
      label: Localized.Labels.view_privacy_policy,
    },
    {
      accessibilityLabel: Localized.Labels.view_terms_and_conditions,
      accessibilityHint: 'Double tap to view terms and conditions',
      onPressed: CommonUtils.handleTerms,
      label: Localized.Labels.view_terms_and_conditions,
    },
    {
      accessibilityLabel: Localized.Labels.delete_account,
      accessibilityHint: 'Double tap to navigate to the delete account screen',
      onPressed: CommonUtils.handleDeleteAccount,
      label: Localized.Labels.delete_account,
    },
  ];
  if (Logger.Log.isLogEnabled()) {
    helpAndOther.push({
      accessibilityLabel: Localized.Labels.send_logs_to_app_developers,
      accessibilityHint: 'Double tap to send logs to app developers',
      onPress: () => Logger.Log.shareLogFile(),
      label: Localized.Labels.send_logs_to_app_developers,
      isShareFile: true,
    });
  }
  return helpAndOther;
};

export function getPaymentOptions() {
  return null;
}

const getGiftingOptions = () => {
  let sendASnack: Array<object> = [];
  if (
    AccountStore.isConsumerSendSnackEnabled() &&
    AccountStore.isSendSnackEnabledForLocation()
  ) {
    sendASnack = [
      {
        accessibilityLabel: Localized.Labels.send_a_snack_title,
        accessibilityHint: 'Double tap to navigate to the send a snack screen',
        onPressed: CommonUtils.sendasnackClicked,
        label: Localized.Labels.send_a_snack_title,
      },
      {
        accessibilityLabel: Localized.Labels.blocked_users,
        accessibilityHint: 'Double tap to navigate to the blocked users screen',
        onPressed: CommonUtils.blockedUsersClicked,
        label: Localized.Labels.blocked_users,
      },
    ];
  }
  return sendASnack;
};

export function getLinkAccountsOptions() {
  return null;
}

export function getBrandWebPage() {
  return '';
}

export function getBrandTitle() {
  return '';
}

export function getSignOutButton(onLogoutSelect: () => void): JSX.Element {
  return (
    <React.Fragment>
      <RoundedButton
        text={Localized.Buttons.signout}
        onPress={onLogoutSelect}
        containerStyle={{
          marginTop: Styles.Spacing.m2,
          borderWidth: 1,
        }}
        buttonType={signOutButtonType()}
        accessible={true}
        color={signOutColor() || ''}
        accessibilityLabel={Localized.Buttons.signout}
        accessibilityHint="Double tap to log out"
        accessibilityRole="button"
        role="button"
        aria-label={Localized.Buttons.signout}
      />
    </React.Fragment>
  );
}

function generateEmailInputFields({
  labelNewEmail,
  valueNewEmail,
  onChangeNewEmail,
  labelConfirmEmail,
  valueConfirmEmail,
  onChangeConfirmEmail,
  maxFontSizeMultiplier,
}) {
  return (
    <>
      <AllyTextInput
        maxFontSizeMultiplier={maxFontSizeMultiplier()}
        label={labelNewEmail}
        value={valueNewEmail}
        accessible={true}
        accessibilityLabel={labelNewEmail}
        accessibilityValue={{text: valueNewEmail}}
        onChangeText={onChangeNewEmail}
        autoCapitalize="none"
        keyboardType="email-address"
      />
      <AllyTextInput
        maxFontSizeMultiplier={maxFontSizeMultiplier()}
        label={labelConfirmEmail}
        value={valueConfirmEmail}
        accessible={true}
        accessibilityLabel={labelConfirmEmail}
        accessibilityValue={{text: valueConfirmEmail}}
        onChangeText={onChangeConfirmEmail}
        autoCapitalize="none"
        keyboardType="email-address"
      />
    </>
  );
}

function generateChangeEmailRoundedButton({
  accessibilityLabel,
  accessibilityHint,
  ariaLabel,
  buttonText,
  onPressHandler,
}) {
  return (
    <RoundedButton
      accessible={true}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      accessibilityHint={accessibilityHint}
      role="button"
      aria-label={ariaLabel}
      buttonType={ButtonType.action}
      text={buttonText}
      onPress={onPressHandler}
    />
  );
}

export default {
  backHeaderDescriptor,
  maxFontSizeMultipleDescriptor,
  getStyleDescriptor,
  getChangePasswordStyleDescriptor,
  getDeleteAcntStyleDescriptor,
  getEditMarketCardStyleDescriptor,
  getHelpStyleDescriptor,
  getManageAcntStyleDescriptor,
  getParentContainerStyle,
  getDeleteAcntDisclaimer,
  showIcon,
  signOutColor,
  signOutButtonType,
  getSettingsOptions,
  getHistoryOptions,
  getSecurityOptions,
  getHelpAndOtherOptions,
  getPaymentOptions,
  getHelpAndOtherStr,
  getUserProfileTextStyleDescriptors,
  getGiftingOptions,
  getLinkAccountsOptions,
  getBrandWebPage,
  getBrandTitle,
  getSignOutButton,
  getSystemLanguageDropDownManageAccount,
  getJobTitleManageAccount,
  getBirthYearDropDownManageAccount,
  getBirthMonthDropDownManageAccount,
  deleteBtnColorrDescriptor,
  getGenderDropDownManageAccount,
  getLastNameManageAccount,
  getFirstNameManageAccount,
  getChangeEmail,
  generateEmailInputFields,
  generateChangeEmailRoundedButton,
};
